import { MagnifyingGlassComponent } from "../components/magnifying-glass.component";
import { JobOfferForm } from "../classes/JobOfferForm";
import { EmailTypes } from "../types/EmailTypes";

export class DesktopAppsPage {
  _desktopAppsPageWrapperEl;

  init() {
    this._desktopAppsPageWrapperEl = document.querySelector('.desktop-apps-page-wrapper');

    if (this._desktopAppsPageWrapperEl) {
      this.initMagnifyingGlass();
    }
    return this;
  }

  initMagnifyingGlass() {
    const images = this._desktopAppsPageWrapperEl.querySelectorAll('.products-list__item__left img');

    images.forEach(image => new MagnifyingGlassComponent(image, '.desktop-apps-page-wrapper__products-description-section'));
  }
}
